import { buildDOM } from '@wheelbox/lithejs-engine';

import './globals.css';

import App from './src/app';
import { initHighlighter } from '@lib/syntax-highlighter';

async function runApp() {
  // Initialize syntax highlighter before building DOM
  await initHighlighter().catch(() => {});

  buildDOM(App({}), document.getElementsByTagName('body')[0], true);
}

window.addEventListener('DOMContentLoaded', runApp);
